import i18n from 'i18next';
import { z } from 'zod/mini';

// Configure global Zod error map to provide user-friendly messages
// This catches the "Invalid input: expected X, received undefined" errors
// that occur when form fields are undefined instead of empty strings
export default function configureZod() {
    z.config({
        customError: (iss) => {
            // Handle "expected string, received undefined" and similar type errors
            if (iss.code === 'invalid_type') {
                if (iss.input === undefined || iss.input === null) {
                    // Use i18n.t() for localized message - falls back to 'Required' if not initialized
                    return i18n.t('validation.required', { defaultValue: 'Required' });
                }
            }
            // Return undefined to fall back to default error message
            return undefined;
        },
    });
}
